import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Role } from '@src/app/components/org/orgprojectlist/assigntemplateroles/model/role';
import { Personproject } from '@src/app/components/org/orgprojectlist/model/personproject';
import { Projectmember } from '@src/app/components/org/orgprojectmemberlist/model/projectmember';
import { Personorg } from '@src/app/components/person/person/model/personorg';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { Projectperson } from '@src/app/models/projectperson';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectassignService {

  serviceUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }
  
  assignToProject(project:Personproject){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }//POST	/projectperson/{projectId}/person/{personId}	Request to join
    return this.http.patch(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/'+project.projectId+"/person/"+project.personId,project,httpOptions);
  }
  getProjectPersons(projectId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    };
    return this.http.get<Projectperson[]>(
      environment.apiUrl +
        "/organization/" +
        SessionHelper.getChoosenOrg() +
        "/projectperson/" +
        projectId +
        "/person/list",
      httpOptions
    );
  }
  saveMember(member:Projectperson){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/projectperson/"+member.projectId+"/person/"+member.personId,member,httpOptions)
  
  }
  deleteMember(member:Projectperson){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/projectperson/"+member.projectId+"/person/"+member.personId,httpOptions)
  
  }

  getRoles(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Role[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId+'/role/list',httpOptions)
  
  }
  assignTemplateRole(project:Project,roleId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var body = {assignedperson: personId};
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId+'/role/'+roleId,JSON.stringify(body),httpOptions)
  
  }
}
